import { useEffect } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { updateDevices } from 'flow/actions/meeting-actions';

const useMeetingDeviceChangeListener = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const onDeviceChange = () => {
            dispatch(updateDevices());
        };

        navigator?.mediaDevices?.addEventListener?.(
            'devicechange',
            onDeviceChange,
        );

        return () => {
            navigator?.mediaDevices?.removeEventListener?.(
                'devicechange',
                onDeviceChange,
            );
        };
    }, [dispatch]);
};

export default useMeetingDeviceChangeListener;
